module.exports = {
    currentVersion: 'v3',
    mercenaries: [
        "Cassius",
        "Dreya",
        "Foulborn",
        // "NoClass",
        "Scourge",
        // "Tad",
        // "Monsters",
    ],
    compare: [
        // "Dreya_Backups",
        // "Scourge_Backups",
        // "Cassius_Backups",
        // "Foulborn_Backups",
    ]
}